/* eslint-disable unused-imports/no-unused-imports */
import { useRouter } from 'next/router'
import cn from 'classnames'
import React, { memo, useEffect, useRef, useState } from 'react'

//
import { SiteDataContext } from '../../components'
import Hamburger from '../Hamburger'
import NewIcon from '../IconNew'
import Logo from '../Logo'
import TopBar from '../TopBar'
import { NavLink } from '../helpers'
import { useLockBodyScroll } from '../hooks'

import { HeaderAction } from './HeaderAction'
import { BUTTON_VARIANT } from '../ButtonNew/ButtonNew'
import { useGlobalData } from '@/pages/_app'
import Image from 'next/image'
import MarketSelector from '../MarketSelector'
/* const MOBILE_NAV_BREAKPOINT = 1200 */

const Header = ({
  primaryAction,
  secondaryAction,
  thirdAction,
  logo = {},
  items = [],
  activeDropdown,
  handleDropdown = () => null,
  toggleNav = () => null,
  isNavOpen,
  children,
  classes = '',
  slugPrefix = '',
  notifications = [],
  hideTopBar = false,
  isMinimalHeader,
  minimalHeaderAction
}) => {
  const { isTextRtl, market, lang } = React.useContext(SiteDataContext)
  const { toggleSideDrawer } = useGlobalData()
  const rootEl = useRef(null)
  const router = useRouter()
  const [trigger, _setTrigger] = useState()
  const [isMarketSelectorOpen, setIsMarketSelectorOpen] = useState(false)

  /* const widowWidth = useWindowWidth() */

  const renderChild = (id) => {
    return children.find((child) => child.key === id)
  }

  useLockBodyScroll(isNavOpen)

  useEffect(() => {
    handleDropdown(null)
    toggleSideDrawer(false)
  }, [router.asPath])

  useEffect(() => {
    if (trigger) {
      setTimeout(() => {
        trigger.refresh(true)
      }, 800)
    }
  }, [router, isNavOpen, trigger])

  const getMinimalHeaderAction = () => {
    if (minimalHeaderAction?.label && minimalHeaderAction?.url) return minimalHeaderAction
  }

  const headerAction = isMinimalHeader ? getMinimalHeaderAction() : secondaryAction
  return (
    <>
      {!hideTopBar ? (
        <TopBar
          headerAction={null}
          slugPrefix={slugPrefix}
          storybookNotifications={notifications}
        />
      ) : null}
      <div className={cn('c-header-container', { 'c-header-container--minimal': isMinimalHeader })}>
        <header
          className={cn('c-header', hideTopBar && 'c-no-topbar', classes, {
            'c-header--rtl': isTextRtl,
            'c-header--minimal': isMinimalHeader
          })}
          ref={rootEl}
          style={{}}
        >
          <nav className="c-header__content">
            <Logo
              withText
              link={logo?.url}
              external={logo?.external}
              anchorProps={logo?.anchorProps}
              variant="black"
            />
            <div className="c-header__navigation-container">
              {items &&
                items.length > 0 &&
                items.map((item) => {
                  if (item.url) {
                    return (
                      <NavLink
                        key={item.id}
                        to={item.url}
                        className="c-header__item"
                        activeclassname="is-active"
                      >
                        <span className="c-header__item-trigger">{item.label}</span>
                      </NavLink>
                    )
                  } else {
                    if (item.navigationItem) {
                      return (
                        <div
                          key={item.id}
                          onMouseEnter={() => handleDropdown(item.id)}
                          onMouseLeave={() => handleDropdown(null)}
                          onFocus={() => handleDropdown(item.id)}
                          onBlur={() => handleDropdown(null)}
                          className={cn('c-header__item c-header__item--dropdown', {
                            'is-active': item.id === activeDropdown
                          })}
                        >
                          <NavLink to={item.navigationItem}>
                            <span className="c-header__item-trigger">
                              {item.label}

                              <NewIcon
                                name="ti-chevron-down"
                                classes="c-header__item-trigger__icon"
                                size={16}
                                weight="700"
                              />
                            </span>
                          </NavLink>

                          {renderChild(item.id)}
                        </div>
                      )
                    }

                    return (
                      <div
                        key={item.id}
                        onMouseEnter={() => handleDropdown(item.id)}
                        onMouseLeave={() => handleDropdown(null)}
                        onFocus={() => handleDropdown(item.id)}
                        onBlur={() => handleDropdown(null)}
                        className={cn('c-header__item c-header__item--dropdown', {
                          'is-active': item.id === activeDropdown
                        })}
                      >
                        <span className="c-header__item-trigger">
                          {item.label}

                          <NewIcon
                            name="ti-chevron-down"
                            classes="c-header__item-trigger__icon"
                            size={16}
                            weight="700"
                          />
                        </span>

                        {renderChild(item.id)}
                      </div>
                    )
                  }
                })}
            </div>
          </nav>

          {!isMinimalHeader && (
            <div className="c-header__actions">
              {hideTopBar && <HeaderAction action={headerAction} actionModal={thirdAction} />}
              {!hideTopBar && <HeaderAction action={thirdAction} />}
              <div
                className="c-header__market-selector"
                role="button"
                tabIndex={0}
                onKeyDown={() => {
                  setIsMarketSelectorOpen(!isMarketSelectorOpen)
                }}
                onClick={() => {
                  setIsMarketSelectorOpen(!isMarketSelectorOpen)
                }}
              >
                <Image
                  key={`${market.title} flag`}
                  priority
                  width={20}
                  height={20}
                  alt={`${market.title} flag`}
                  src={market.flagRoundUrl || market.flagUrl}
                />
                {lang.toUpperCase()}
              </div>
              <div
                style={{
                  height: '28px',
                  background: '#dedede',
                  width: '1px'
                }}
              ></div>
              <HeaderAction
                action={headerAction}
                variant={BUTTON_VARIANT.SECONDARY}
                style={{ padding: 0 }}
              />
              <HeaderAction action={primaryAction} />
            </div>
          )}

          <div className="c-header__mobile-content">
            <div className="c-header__logo">
              <Logo
                withText
                link={logo?.url}
                external={logo?.external}
                anchorProps={logo?.anchorProps}
                variant="black"
              />
            </div>
            <Hamburger isOpen={isNavOpen} toggleIsOpen={toggleNav} classes="c-header__hamburger" />
          </div>
        </header>

        <MarketSelector
          isOpen={isMarketSelectorOpen}
          onClose={() => setIsMarketSelectorOpen(false)}
        />

        <div className="c-header__mobile-nav">{renderChild('mobile-nav')}</div>
      </div>
    </>
  )
}

export default memo(Header)
